import { render, staticRenderFns } from "./CompanyListBlock.vue?vue&type=template&id=1d401ce3&scoped=true"
import script from "./CompanyListBlock.vue?vue&type=script&lang=js"
export * from "./CompanyListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d401ce3",
  null
  
)

export default component.exports